import { isDefined } from './helpers';

export const currencyFormatter = (
  value: number,
  isCurrency: boolean,
  round: boolean = false
) => {
  let formattedValue = value;

  if (round) {
    formattedValue = Math.round(value);
  }

  return isCurrency
    ? `$ ${formattedValue.toLocaleString()}`
    : formattedValue.toLocaleString();
};

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

export const formatCurrency = (
  value?: number | null,
  fractionDigits = 2
): string | null => {
  if (!isDefined(value)) {
    return null;
  }

  const formattedValue = value.toFixed(fractionDigits);

  return `${value < 0 ? '-' : ''}$${Math.abs(
    Number(formattedValue)
  ).toLocaleString()}`;
};

export const formatPercentage = (
  value?: number | null,
  fractionDigits = 2,
  withSign = false
): string | null => {
  if (!isDefined(value)) {
    return null;
  }

  const formattedValue = value.toFixed(fractionDigits);
  const sign = value > 0 ? '+' : '';

  return `${withSign ? sign : ''}${formattedValue}%`;
};
